import React, { useRef, useState, useEffect } from 'react';
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import * as NavigationActions from './actions';

import classnames from 'classnames';
import tkggbsLogoHoriz from './tkggbs-logo-horiz.svg';
import gold from '../icons/gold';
import coin from '../icons/coin';
import ledger from '../icons/ledger';
import gear from '../icons/gear';

//import '../css/NavBar.css';

// Note that I have replaced "<a href=" to "<Link" in this source and selected-actions.js.  If some problem occures, I should restore the original statement.
const NavLink = ({
  dispatch,
  to,
  borderWidth,
  icon,
  disabled,
  children
}) => {
  const Svg = icon;
  const pathname = useLocation().pathname;
  const active = pathname === to;
  const anchorClass = classnames({
        'bg-white-10 navbar-item-active': active,
        'o-50 no-pointer-events': disabled
      }, ['dib db-l white no-underline f7 hover-bg-white-10 tc bb bw0-l b--navy']);
  const svgClass = classnames({
    'o-100': active,
    'o-50': !active
      }, ['fill-current-color mv2']);
  const [ previousPathname, setPreviousPathname ] = useState(null);

  useEffect(() => {
    dispatch(notifyPreviousPathname(previousPathname));
    setPreviousPathname(pathname);
  }, [pathname]);
  
  return (
    <Link to={to} className={anchorClass} style={{ borderWidth: borderWidth }} role='menuitem' title={children}>
      <div className='db ph2 pv2'>
        <div className='db'>
          <Svg width='46' role='presentation' className={svgClass} />
        </div>
        <div className={`${active ? 'o-100' : 'o-50'} db f7 tc montserrat ttu fw1`} style={{ whiteSpace: 'pre-wrap' }}>
          {children}
        </div>
      </div>
    </Link>
  );
}

const NavBar = ({
  dispatch
}) => {
  const elm = useRef();

  const [ dimention, setDimention ] = useState({
    fullWidth: window.innerWidth,
    fullHeight: window.innerHeight });

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleResize = () => {
    setDimention({
      fullWidth: window.innerWidth,
      fullHeight: window.innerHeight
    });
  }

  return (
    <div className='z-4 w-100 flex justify-between overflow-x-hidden'>
      <div className='flex'>
        <Link to='/welcome'>
          <img className='pt3 pl3 z-4' style={{ height: 60 }} src={tkggbsLogoHoriz} />
        </Link>
        <PrivateNavLink to='/purchase' icon={gold}>PURCHASE</PrivateNavLink>
        <PrivateNavLink to='/sell' icon={coin}>SELL</PrivateNavLink>
        <PrivateNavLink to='/ledger' icon={ledger}>LEDGER</PrivateNavLink>
      </div>
      <div className='flex db overflow-x-hidden-l overflow-y-hidden'>
        <PrivateNavLink to='/admin' icon={gear}>ADMIN</PrivateNavLink>
      </div>
    </div>
  )
}

const notifyPreviousPathname = previousPathname => {
  return {
    type: NavigationActions.NAVIGATION_CHANGE_PAGE,
    previousPathname: previousPathname
  }
}

const notifyNavBarHorizDimention = (navBarWidth, navBarHeight) => {
  return {
    type: NavigationActions.HORIZHEIGHT_DETERMINDED
  }
}

const mapStateToProps = state => ({
  isValid: state.login.isValid,
})

const PrivateNavLink = connect(mapStateToProps)(NavLink);
export default connect(mapStateToProps)(NavBar);
